import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SelectedNum from '../views/SelectedNum.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/register',
    name: '注册',
    component: Register
  },
  {
    path: '/admin',
    name: '后台管理',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/',
    name: '首页',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/SelectedNum',
    name: '选号',
    component: SelectedNum,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 从localStorage读取登录状态
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
  const currentUserStr = localStorage.getItem('currentUser')
  let currentUser = null
  if (currentUserStr) {
    try {
      currentUser = JSON.parse(currentUserStr)
    } catch (e) {
      console.error('解析用户信息失败', e)
    }
  }

  // 如果访问登录页或注册页且已登录，根据角色跳转
  if ((to.path === '/login' || to.path === '/register') && isLoggedIn) {
    if (currentUser && currentUser.role === 'admin') {
      next('/admin')
    } else {
      next('/')
    }
    return
  }

  // 检查是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }

    // 检查是否需要管理员权限
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (!currentUser || currentUser.role !== 'admin') {
        next({
          path: '/',
          query: { error: 'no_permission' }
        })
        return
      }
    }
  }

  next()
})

export default router

